import React from 'react';

const ProductOverview = () => {
    return (
        <section style={{ background: "linear-gradient(180deg, #F3F5FF 0%, #E5ECFF 100%)" }} className="w-full py-16 lg:py-24 flex items-center justify-center select-none">
            <div className="max-w-[1440px] w-full  flex flex-col md:flex-row overflow-hidden px-[20px] lg:px-[80px] ">

                <div className="w-full max-w-[498px] min-h-[auto] md:min-h-[378px] relative bg-[#031525]">
                    <img
                        src="/assets/data/img1.png"
                        alt="Product Digital Visual"
                        className="w-full h-full object-cover"
                    />
                </div>

                <div className="w-full md:w-full max-w-[785px] p-8 sm:p-12 lg:p-16 flex flex-col justify-center text-left border border-[#01386A45] bg-white">
                    <h2 className="text-[20px] sm:text-[30px] font-[600] text-[#01386A] tracking-tight mb-6">
                        Service Overview
                    </h2>

                    <p className="text-[14px] sm:text-[16px] font-graphik text-[#49577A] font-[500] leading-relaxed mb-5">
                        Mobikode's Data Extraction & Analytics solution connects directly to your plant's DCS, Data Acquisition system, or Historian and turns raw process data into clear, actionable insight — without disturbing plant operations, and without adding manual work for your team.
                    </p>

                    <p className="text-[14px] sm:text-[16px] font-graphik text-[#49577A] font-[500] leading-relaxed">
                        Whether you want a one-time process data audit, an on-demand analysis tool for your own PC or intranet, or a continuously improving cloud platform your whole team can use, Mobikode configures the solution around how your plant actually runs.
                    </p>
                </div>

            </div>
        </section>
    );
};

export default ProductOverview;